<form [formGroup]="sectionForm" class="flex flex-column h-full">
  <div class="col-12 flex-grow-1">
    <p-tabView
      #tv
      styleClass="tabview-custom flex flex-column h-full"
      [(activeIndex)]="selectedIndex"
      (onChange)="changeLang($event)">
      <ng-container formArrayName="sections">
        <ng-container
          *ngFor="let itemForm of sections.controls; let i = index"
          [formGroupName]="i">
          <p-tabPanel>
            <ng-template pTemplate="header">
              <div class="flex align-items-center gap-2">
                <img
                  alt="flag"
                  src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                  [class]="itemForm.value.lang | flagLanguage"
                  style="width: 18px" />
                <span class="font-bold white-space-nowrap m-0">
                  {{ (itemForm.value.lang | infoLanguage)?.name }}
                </span>
                @if((itemForm.value.lang | infoLanguage)?.master || false) {
                <p-tag [value]="'M'" pTooltip="Master"></p-tag>
                }
              </div>
            </ng-template>
            <div class="flex flex-column">
              <ls-form-field-molecule
                [labelText]="sectionType.title_label || 'Title'"
                [labelFor]="'titulo'"
                [required]="
                  (itemForm.value.lang | infoLanguage)?.master || false
                "
                formName="title"
                [group]="section(i)"
                class="col-12"
                [loading]="isLoading()" />
              <div class="col-12">
                <ls-label-atom
                  labelClass="block mb-2"
                  [text]="sectionType.description_label || 'Description'"
                  forId="editor"></ls-label-atom>
                <p-editor
                  id="editor"
                  *ngIf="!isLoading()"
                  formControlName="description"
                  [style]="{ height: '100px' }" />
              </div>
            </div>
          </p-tabPanel>
        </ng-container>
      </ng-container>
      <div class="p-2">
        <ls-single-upload-file-atom
          #fileUpload
          (onSelect)="onFileSelect($event)"
          (onRemove)="onFileRemove($event)" />
      </div>
    </p-tabView>
  </div>

  <div class="flex gap-2 dates-container align-items-center col-12">
    <ls-checkbox-atom
      ariaLabel="Activar fechas"
      formControlName="datesChecked"
      (change)="clickEnableDates($event)"></ls-checkbox-atom>
    <ls-label-atom
      text="Fecha Inicio"
      [required]="sectionForm.controls['datesChecked'].value"></ls-label-atom>
    <ls-calendar-atom
      #dateIni
      formControlName="date_ini"
      [nextCalendar]="dateEnd"
      [loading]="isLoading()" />
    <ls-label-atom
      text="Fecha Fin"
      [required]="sectionForm.controls['datesChecked'].value"></ls-label-atom>
    <ls-calendar-atom
      #dateEnd
      formControlName="date_end"
      [minDate]="dateIni.date"
      [loading]="isLoading()" />
  </div>
  <ls-cancel-save-molecule
    (cancelClick)="closeDialog()"
    (saveClick)="saveSection()"
    [processing]="saving" />
</form>
